import React from 'react'
import moment from 'moment-timezone'

import CalendarDayCell from './CalendarDayCell'
import { buildMonthMatrix, dayKey, eventsInMonth, groupByDay, monthKey } from './calendarHelpers'

import css from './style.scss'

/**
 * A display calendar, not a date picker — so this is a plain semantic table
 * rather than an ARIA grid. Native table semantics plus real links give better
 * screen-reader output than a roving-tabindex implementation would.
 */
class CalendarMonthGrid extends React.Component {
  constructor (props) {
    super(props)
    this.state = { expandedDays: {} }
  }

  componentWillReceiveProps (nextProps) {
    // Expansion is per-month disclosure; carrying it across a month change
    // would silently expand unrelated days.
    if (monthKey(nextProps.month) !== monthKey(this.props.month)) {
      this.setState({ expandedDays: {} })
    }
  }

  toggleDay (date) {
    const key = dayKey(date)
    this.setState(state => ({
      expandedDays: { ...state.expandedDays, [key]: !state.expandedDays[key] }
    }))
  }

  render () {
    const { month, events } = this.props
    const grouped = groupByDay(events)
    const weeks = buildMonthMatrix(month)
    const total = eventsInMonth(grouped, month)
    const weekdaysShort = moment.weekdaysShort()
    const weekdaysLong = moment.weekdays()

    return (
      <table className={css.monthGrid}>
        <caption className={css.visuallyHidden}>
          Events in {moment(month).format('MMMM YYYY')}.
          {` ${total} event${total === 1 ? '' : 's'}.`}
        </caption>
        <thead>
          <tr>
            {weekdaysShort.map((short, index) => (
              <th key={short} scope='col' className={css.weekdayHeading}>
                <abbr title={weekdaysLong[index]}>{short}</abbr>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, weekIndex) => (
            <tr key={weekIndex}>
              {week.map(day => {
                const key = dayKey(day.date)
                return (
                  <CalendarDayCell
                    key={key}
                    day={day}
                    events={grouped[key] || []}
                    expanded={!!this.state.expandedDays[key]}
                    onToggle={date => this.toggleDay(date)}
                  />
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

CalendarMonthGrid.propTypes = {
  month: React.PropTypes.object.isRequired,
  events: React.PropTypes.array.isRequired
}

export default CalendarMonthGrid
